import sanitizeHtml from "sanitize-html";
const tagPattern = /<[a-z!/]/i;
const colorPattern = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|[a-z]+)$/i;
const sizePattern = /^[\d.]+(px|pt|em|rem|%)$/;
const fontPattern = /^[\w\s,"'-]+$/;
const keywordPattern = /^[a-z-]+$/;
const sanitizeOptions = {
    allowedTags: [
        "p",
        "br",
        "div",
        "span",
        "b",
        "strong",
        "i",
        "em",
        "u",
        "s",
        "ul",
        "ol",
        "li",
        "a",
        "h1",
        "h2",
        "h3",
        "h4",
        "blockquote",
    ],
    allowedAttributes: {
        a: ["href", "target", "rel"],
        "*": ["style"],
    },
    allowedStyles: {
        "*": {
            color: [colorPattern],
            "background-color": [colorPattern],
            "font-size": [sizePattern],
            "font-family": [fontPattern],
            "font-weight": [keywordPattern, /^\d{3}$/],
            "font-style": [keywordPattern],
            "text-decoration": [keywordPattern],
            "text-align": [keywordPattern],
        },
    },
    allowedSchemes: ["http", "https", "mailto"],
    allowProtocolRelative: false,
    transformTags: {
        a: sanitizeHtml.simpleTransform("a", {
            target: "_blank",
            rel: "noopener noreferrer",
        }),
    },
};
const escapeHtml = (value) => value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
const containsMarkup = (value) => tagPattern.test(value);
export const sanitizeEventDescription = (description) => containsMarkup(description)
    ? sanitizeHtml(description, sanitizeOptions)
    : description;
export const eventDescriptionAsHtml = (description) => containsMarkup(description)
    ? sanitizeHtml(description, sanitizeOptions)
    : escapeHtml(description).replace(/\r?\n/g, "<br />");
const decodeEntities = (value) => value
    .replace(/&nbsp;/g, " ")
    .replace(/\u00a0/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");
export const eventDescriptionAsPlainText = (description) => {
    if (!containsMarkup(description)) {
        return description;
    }
    const withBreaks = description
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|li|h[1-4]|blockquote)>/gi, "\n");
    const text = sanitizeHtml(withBreaks, {
        allowedTags: [],
        allowedAttributes: {},
    });
    return decodeEntities(text)
        .replace(/\n{3,}/g, "\n\n")
        .trim();
};
//# sourceMappingURL=event-description.js.map